<div #talkjsContainer class="messaging-inbox">
  <div class="spinner mx-auto"></div>
</div>
